import { useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useNavigate } from "react-router";
import MyLifeSaverLogo from "../../assets/images/mylifesaverLogo.png";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { useAuthContext } from "../../context/AuthContext";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { setIsLoggedIn, setUserProfile } = useAuthContext();
  const navigate = useNavigate();
  const { request } = useRequest();

  const onFinish = (values) => {
    setLoading(true);
    request({
      url: apiPath.login,
      method: "POST",
      data: {
        email: values.email?.trim()?.toLowerCase(),
        password: values.password,
      },
      onSuccess: (res) => {
        setLoading(false);
        const payload = res?.data ?? res;
        const token = payload?.token;
        const user = payload?.user;

        if (!token || !user) {
          ShowToast("Login failed. Invalid response.", Severty.ERROR);
          return;
        }

        const userType = user?.userType || user?.type;
        if (userType === "user") {
          ShowToast(
            res?.message ?? "Users with role 'user' are not allowed to access the panel.",
            Severty.ERROR
          );
          return;
        }

        const normalizedUser = { ...user, type: user.type || user.userType };
        setIsLoggedIn(true);
        localStorage.setItem("token", token);
        localStorage.setItem("userProfile", JSON.stringify(normalizedUser));
        setUserProfile(normalizedUser);
        ShowToast(res?.message ?? "Login successfully", Severty.SUCCESS);

        const type = normalizedUser.type || normalizedUser.userType;
        if (type === "Admin") navigate("/sub-admin");
        else if (type === "SubAdmin") navigate("/user-management");
        else navigate("/");
      },
      onError: (err) => {
        setLoading(false);
        const msg = err?.response?.data?.message ?? err?.message ?? "Login failed";
        ShowToast(msg, Severty.ERROR);
      },
    });
  };

  return (
    <div className="main-new_login-page-main-classs">
      <div className="login-header-main" />
      <Card className="main-new_login-page-main-card">
        <div className="header-login">
          <img
            src={MyLifeSaverLogo}
            alt="My Life Saver"
            style={{ maxWidth: "100%", height: "auto", maxHeight: 56, marginBottom: 12 }}
          />
          <h6>Login with your email and password</h6>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish} style={{ marginTop: 20 }}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter email" autoComplete="username" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input.Password placeholder="Enter password" autoComplete="current-password" />
          </Form.Item>

          <Button type="primary" size="large" block loading={loading} htmlType="submit">
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
}
